import { styled, mixins, theme } from 'ui/theme';

export const Radio = {
  Input: styled('input')`
    appearance: none;
    border-radius: 50%;
    border: 0.125rem solid currentColor;
    color: currentColor;
    cursor: pointer;
    display: grid;
    flex: 0 0 auto;
    font: inherit;
    height: ${theme.sizes[4]};
    place-content: center;
    transform: translateY(-0.075rem);
    width: ${theme.sizes[4]};

    &::before {
      background-color: ${theme.colors.action.navigation.standard.static};
      border-radius: 50%;
      content: '';
      height: ${theme.sizes[2]};
      transform: scale(0);
      transition: 100ms transform ease-in-out;
      width: ${theme.sizes[2]};
    }

    &[data-size=${theme.sizes.xs}] {
      font-size: ${theme.sizes.xs};

      &::before {
        height: calc(${theme.sizes.xs} / 2);
        width: calc(${theme.sizes.xs} / 2);
      }
    }

    &:checked::before {
      transform: scale(1);
    }

    &:focus-within {
      color: ${theme.colors.action.navigation.standard.static};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${theme.colors.build.mediumMedium};

      &:before {
        background-color: ${theme.colors.build.mediumMedium};
      }
    }
  `,

  Label: styled('label')`
    ${mixins.baseFont};
    align-items: center;
    display: flex;
    gap: ${theme.space[2]};
    cursor: pointer;

    &[data-disabled='true'] {
      cursor: not-allowed;
      color: ${theme.colors.build.mediumMedium};
    }

    &[data-size='xs'] {
      font-size: ${theme.sizes.xs};
    }
  `,
};
